import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import IconButton from '@mui/material/IconButton'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { capitalizeFirstLetter } from '../../_common/_helpers/string'
import CustomCheckboxField from '../../_common/_form_fields/CustomCheckboxField'
import OpenStackServicesEditRegion from './OpenStackServicesEditRegion'

const OpenStackServicesEditService = (props) => {
  const {
    serviceName,
    configs,
    setConfigs,
    configOptions,
    setConfigOptions,
    supportedServiceConfigs,
    billingServicesConfigurable,
    expandedPanel,
    handleChangeExpandedPanel,
    identityProviderExists,
    validateFormFields,
    errors,
  } = props
  const theme = useTheme()

  const [expandedSubPanel, setExpandedSubPanel] = useState('')
  const [regions, setRegions] = useState([])
  const [isIdentityProvider, setIsIdentityProvider] = useState(false)

  const accordionStyle = {
    background: 'none',
    boxShadow: 'none'
  }

  const summaryStyle = {
    background: theme.palette.violetsAreBlue,
    color: 'white',
    fontSize: '18px',
  }

  const detailsStyle = {
    border: `${theme.palette.violetsAreBlue} 1px solid`,
    background: 'white',
    boxShadow: 'none',
    padding: '0px',
  }

  const regionSummaryStyle = {
    borderBottom: `${theme.palette.oxfordBlue} 1px solid`,
    color: theme.palette.oxfordBlue,
    fontSize: '18px',
    fontWeight: '500',
  }

  const serviceCheckboxStyle = {
    color: 'white',

    '&.Mui-checked': {
      color: 'white',
    },

    '& .MuiSvgIcon-root': {
      fontSize: 24,
    },
  }

  const regionCheckboxStyle = {
    color: theme.palette.violetsAreBlue,

    '&.Mui-checked': {
      color: theme.palette.violetsAreBlue,
    },

    '& .MuiSvgIcon-root': {
      fontSize: 24,
    },
  }

  const getSelectFieldList = (service, field, sub_field) => {
    let result = []
    let options_list = []

    const service_object = supportedServiceConfigs.find(item => item.service === service)

    if (sub_field && service_object && service_object.config_params && service_object.config_params[field] && service_object.config_params[field][sub_field] && service_object.config_params[field][sub_field].length > 0) {
      options_list = service_object.config_params[field][sub_field]
    } else if (service_object && service_object.config_params && service_object.config_params[field] && service_object.config_params[field].length > 0) {
      options_list = service_object.config_params[field]
    }

    options_list.forEach(item => {
      result.push({
        keyword: capitalizeFirstLetter(item),
        value: item,
      })
    })

    return result
  }

  const getServiceTitle = () => {
    const service_object = supportedServiceConfigs.find(item => item.service === serviceName)
    return service_object ? service_object.title.value : serviceName
  }

  const getServiceChecked = () => {
    const config_options_object = configOptions.find(item => item.service_name === serviceName && item.billing_new)
    return config_options_object ? true : false
  }

  const getRegionChecked = (region_name) => {
    const config_options_object = configOptions.find(item => item.service_name === serviceName && item.region_name === region_name && item.billing_new)
    return config_options_object ? true : false
  }

  const handleChangeExpandedSubPanel = (panel) => (event, newExpanded) => {
    setExpandedSubPanel(newExpanded ? panel : false)
  }

  const handleStopPropagation = (event) => {
    event.stopPropagation()
  }

  const handleChangeBillingForService = (value) => {
    setConfigOptions(prev => {
      let new_data = []

      prev.forEach(item => {
        if (item.service_name === serviceName) {
          new_data.push({ ...item, billing_new: value })
        } else {
          new_data.push({ ...item })
        }
      })

      return new_data
    })
  }

  const handleChangeBillingForRegion = (value, field_key) => {
    setConfigOptions(prev => {
      let new_data = []

      prev.forEach(item => {
        if (item.service_name === serviceName && item.region_name === field_key) {
          new_data.push({ ...item, billing_new: value })
        } else {
          new_data.push({ ...item })
        }
      })

      return new_data
    })
  }

  const handleClickAddRegion = (event) => {    
    if (expandedPanel === serviceName) {
      event.stopPropagation()
    }

    setConfigs(prev => [
      ...prev,
      {
        is_identity_provider: false,
        service_name: serviceName,
        service_domain: '',
        service_version: '',
        region_name: 'Region-' + (Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000),
        resource_suspend_period: '',
        resource_delete_period: '',
        resource_suspend_policy: '',
        resource_delete_policy: '',
        credentials: {
          app_auth_id: '',
          app_auth_secret: '',
        }  
      }
    ])

    setConfigOptions(prev => [
      ...prev,
      {
        service_name: serviceName,
        region_name: 'Region-' + (Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000),
        billing_current: false,
        billing_new: true,
      }
    ])
  }

  const handleClickRemoveRegion = (event, region_name) => {
    event.stopPropagation()

    setConfigs(prev => prev.filter(item => (item.service_name !== serviceName || item.region_name !== region_name)))
    
    setConfigOptions(prev => {
      let new_data = []

      prev.forEach(item => {
        if (item.service_name === serviceName && item.region_name === region_name) {
          new_data.push({ ...item, billing_new: false })
        } else {
          new_data.push({ ...item })
        }
      })

      return new_data
    })
  }

  useEffect(() => {
    const identity_service = configs.find(item => item.service_name === serviceName && item.is_identity_provider)
    setIsIdentityProvider(identity_service ? true : false)
    setRegions(configs.filter(item => item.service_name === serviceName))
  }, [configs, serviceName])
  
  return (
    <>
      <Accordion
        expanded={expandedPanel === serviceName}
        onChange={handleChangeExpandedPanel(serviceName)}
        sx={accordionStyle}
      >
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon sx={{ color: 'white' }} />}
          sx={{
            ...summaryStyle,
            borderRadius: expandedPanel === serviceName ? '10px 10px 0px 0px' : '0px',
          }}
        >
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='flex-start'
            spacing={1}
          >
            {
              !billingServicesConfigurable &&
              <Box onClick={handleStopPropagation}>
                <CustomCheckboxField
                  checked={getServiceChecked()}
                  handleChange={handleChangeBillingForService}
                  sx={serviceCheckboxStyle}
                />
              </Box>
            }            
            <Box>{getServiceTitle()}</Box>
            {
              (!isIdentityProvider && billingServicesConfigurable) &&
              <IconButton sx={{ color: 'white' }} onClick={handleClickAddRegion}>
                <AddCircleOutlineIcon />
              </IconButton>
            }
          </Stack>          
        </AccordionSummary>
        <AccordionDetails sx={detailsStyle}>

          {
            regions.length === 1 && regions.map((item, index) => (
              <Box key={index} sx={{ padding: '20px' }}>
                <OpenStackServicesEditRegion
                  {...item}
                  setConfigs={setConfigs}
                  api_version_list={getSelectFieldList(serviceName, 'api_version')}
                  identityProviderExists={identityProviderExists}
                  billingServicesConfigurable={billingServicesConfigurable}
                  validateFormFields={validateFormFields}
                  errors={errors}
                />
              </Box>              
            ))
          }

          {
            regions.length > 1 && regions.map((item, index) => (
              <Accordion
                key={index}
                expanded={expandedSubPanel === index}
                onChange={handleChangeExpandedSubPanel(index)}
                sx={accordionStyle}
              >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  sx={regionSummaryStyle}
                >
                  <Stack
                    direction='row'
                    alignItems='center'
                    justifyContent='flex-start'
                    spacing={1}
                  >
                    {
                      !billingServicesConfigurable &&
                      <Box onClick={handleStopPropagation}>
                        <CustomCheckboxField
                          checked={getRegionChecked(item.region_name)}
                          handleChange={handleChangeBillingForRegion}
                          field_key={item.region_name}
                          sx={regionCheckboxStyle}
                        />
                      </Box>
                    }                    
                    <Box>{item.region_name}</Box>
                    {
                      (index > 0 && billingServicesConfigurable) &&
                      <IconButton onClick={(event) => handleClickRemoveRegion(event, item.region_name)}>
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                    }
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <OpenStackServicesEditRegion
                    key={index}
                    {...item}
                    setConfigs={setConfigs}
                    api_version_list={getSelectFieldList(serviceName, 'api_version')}
                    identityProviderExists={identityProviderExists}
                    billingServicesConfigurable={billingServicesConfigurable}
                    validateFormFields={validateFormFields}
                    errors={errors}
                  />
                </AccordionDetails>              
              </Accordion>
            ))
          }

        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default OpenStackServicesEditService